import {
  GrowthDashboardTopBarActions,
  LandingPagePreviewView,
  LP_CREATE_META,
  LP_CREATE_PERFORMANCE,
  LP_CREATE_TESTING,
} from '@elva/ui';
import type { LpBlock, LpPreviewMeta } from '@elva/ui';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useNotify } from '@/data/notifications';
import { blocksToWirePayload, createLandingPage } from '../api';

export function LandingPageCreatePage() {
  const navigate = useNavigate();
  const notify = useNotify();
  const [saving, setSaving] = useState(false);

  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const handleCreate = useCallback(
    async (blocks: LpBlock[], meta?: LpPreviewMeta) => {
      if (!blocks.length) {
        notify.error('Add at least one block before creating');
        return;
      }
      const title = meta?.title?.trim() || 'New Landing Page';
      setSaving(true);
      try {
        const result = await createLandingPage({
          title,
          preset: meta?.preset || LP_CREATE_META.preset,
          blocks: blocksToWirePayload(blocks),
        });
        const row = result as Record<string, unknown>;
        const id = String(
          row.landing_page_id ??
            row.landingPageId ??
            row.entity_id ??
            row.entityId ??
            row.id ??
            '',
        ).trim();
        if (id) {
          notify.success('Landing page created');
          navigate(`/landing-pages/${id}`);
          return;
        }
        notify.success('Landing page created');
        navigate('/landing-pages');
      } catch (error) {
        notify.error(error, 'Could not create landing page');
      } finally {
        setSaving(false);
      }
    },
    [navigate, notify],
  );

  return (
    <LandingPagePreviewView
      {...viewProps({
        mode: 'create' as const,
        draft: {
          meta: LP_CREATE_META,
          performance: LP_CREATE_PERFORMANCE,
          blocks: [],
          testing: LP_CREATE_TESTING,
        },
        saving,
        onBack: () => navigate('/landing-pages'),
        onApplyBlocks: handleCreate,
      })}
    />
  );
}
